export default function ($form, callback) {
	var $input = $form.find('input[name="recaptcha_token"]');
	var key = jQuery('meta[name="recaptcha_client_id"]').attr('content');
	var timer, done = function (token, error) {
		if (!done.called) {
			done.called = true;
			clearTimeout(timer);
			if (token) $input.val(token);
			if (error) console.error('reCAPTCHA error:', error);
			if (callback) callback(token || null, error || null);
		}
	};

	if (!$input.length) {
		$input = jQuery('<input type="hidden" name="recaptcha_token">');
		$form.append($input);
	}

	if (typeof grecaptcha === 'undefined' || !key) {
		return done(null, 'grecaptcha not loaded or missing site key');
	}

	timer = setTimeout(function () { done(null, 'reCAPTCHA timeout'); }, 10000);

	grecaptcha.ready(function () {
		try {
			Promise.resolve(grecaptcha.execute(key, { action: 'submit' }))
				.then(function (t) { done(t); }, function (e) { done(null, e); });
		} catch (e) {
			done(null, e);
		}
	});
};